"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectLevel2State = exports.selectFuturesOpenRequestsLoading = exports.selectFuturesOpenOrdersSelector = exports.selectActiveRecentTrades = exports.rawFuturesLevel2SellSelector = exports.rawFuturesLevel2BuySelector = exports.optimizedFuturesLevel2Selector = exports.futuresSpreadSelector = exports.futuresSellOrderCostSelector = exports.futuresSellOpenOrdersSelector = exports.futuresRecentTradesSelector = exports.futuresRecentTradesFetchingSelector = exports.futuresOpenOrdersSelector = exports.futuresOpenOrdersCurrencySelector = exports.futuresOpenOrdersCountSelector = exports.futuresLevel2SellSelector = exports.futuresLevel2Selector = exports.futuresLevel2LoadingSelector = exports.futuresLevel2BuySelector = exports.futuresInactiveOrdersSelector = exports.futuresInactiveOrdersFetchingSelector = exports.futuresInactiveOrdersBaseSelector = exports.futuresFilledOrdersSelector = exports.futuresFilledOrdersRawSelector = exports.futuresFilledOrdersFetchingSelector = exports.futuresFilledOrdersBaseSelector = exports.futuresBuyOrderCostSelector = exports.futuresBuyOpenOrdersSelector = void 0;
var _bignumber = require("bignumber.js");
var _reselect = require("reselect");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _instrumentPositionSelectors = require("../../selectors/instrumentPositionSelectors");
var _futuresInstrumentsSelector = require("./futuresInstrumentsSelector");
var _futuresSelectors = require("./futuresSelectors");
var _orderHelper = require("../../../helpers/orderHelper");
var _decimalPlacesHelper = require("../../../helpers/decimalPlaces/decimalPlacesHelper");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var selectFuturesState = function selectFuturesState(state) {
  return state.futures;
};

//#region Futures Orders Selectors
var selectLevel2State = exports.selectLevel2State = function selectLevel2State(state) {
  return selectFuturesState(state).level2;
};
var selectFuturesOrdersState = function selectFuturesOrdersState(state) {
  return selectFuturesState(state).orders;
};
var selectFuturesOpenOrdersSelector = exports.selectFuturesOpenOrdersSelector = (0, _reselect.createSelector)(selectFuturesOrdersState, function (orders) {
  return orders.openOrders;
});
var selectFuturesOpenRequestsLoading = exports.selectFuturesOpenRequestsLoading = (0, _reselect.createSelector)(selectFuturesOrdersState, function (orders) {
  return orders.fetchingOpenOrders;
});
var futuresLevel2LoadingSelector = exports.futuresLevel2LoadingSelector = (0, _reselect.createSelector)(selectLevel2State, function (level2) {
  return level2.fetching;
});

// Raw data selectors
var rawFuturesLevel2BuySelector = exports.rawFuturesLevel2BuySelector = (0, _reselect.createSelector)(selectLevel2State, function (level2) {
  return level2.buy;
});
var rawFuturesLevel2SellSelector = exports.rawFuturesLevel2SellSelector = (0, _reselect.createSelector)(selectLevel2State, function (level2) {
  return level2.sell;
});
var futuresOpenOrdersSelector = exports.futuresOpenOrdersSelector = (0, _reselect.createSelector)([selectFuturesOpenOrdersSelector, _futuresSelectors.futuresAccountIdSelector, _futuresInstrumentsSelector.futuresSelectedInstrumentIdSelector], function (orders, accountId, selectedInstrumentId) {
  return orders.filter(function (order) {
    return order.OrderState === 'Working' && (!accountId || order.Account === accountId) && (!selectedInstrumentId || order.Instrument === selectedInstrumentId);
  }).sort(function (a, b) {
    return b.ReceiveTime - a.ReceiveTime;
  });
});
var futuresOpenOrdersCountSelector = exports.futuresOpenOrdersCountSelector = (0, _reselect.createSelector)(futuresOpenOrdersSelector, function (orders) {
  return orders.length;
});
var selectFuturesOrderCostState = function selectFuturesOrderCostState(state) {
  return selectFuturesState(state).futuresOrderCostInfo;
};
var futuresBuyOrderCostSelector = exports.futuresBuyOrderCostSelector = (0, _reselect.createSelector)(selectFuturesOrderCostState, function (orderTotal) {
  return orderTotal === null || orderTotal === void 0 ? void 0 : orderTotal.BuyOrderCost;
});
var futuresSellOrderCostSelector = exports.futuresSellOrderCostSelector = (0, _reselect.createSelector)(selectFuturesOrderCostState, function (orderTotal) {
  return orderTotal === null || orderTotal === void 0 ? void 0 : orderTotal.SellOrderCost;
});
// Convert orders to currency format
var futuresOpenOrdersCurrencySelector = exports.futuresOpenOrdersCurrencySelector = (0, _reselect.createSelector)([futuresOpenOrdersSelector, _instrumentPositionSelectors.instrumentsWithProductFullNamesAndProductSymbols, _futuresInstrumentsSelector.futuresSelectedInstrumentIdSelector], function (orders, instruments, selectedInstrumentId) {
  return orders.filter(function (order) {
    return selectedInstrumentId === order.Instrument;
  }).map(function (order) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.Instrument;
    });
    if (!instrument) {
      return order;
    }
    var Product1Symbol = instrument.Product1Symbol,
      Product2Symbol = instrument.Product2Symbol;
    var quantity = (0, _numberFormatter.currency)(order.Quantity, Product1Symbol);
    var origQuantity = (0, _numberFormatter.currency)(order.OrigQuantity, Product1Symbol);
    var price = (0, _numberFormatter.currency)(order.Price, Product2Symbol);
    return _objectSpread(_objectSpread({}, order), {}, {
      quantity: quantity,
      OrigQuantity: origQuantity,
      Price: price,
      instrument: instrument
    });
  });
});

// Buy and Sell Open Orders Selectors
var futuresBuyOpenOrdersSelector = exports.futuresBuyOpenOrdersSelector = (0, _reselect.createSelector)(futuresOpenOrdersCurrencySelector, function (orders) {
  return orders.filter(function (order) {
    return order.Side === 'Buy' && order.OrderType !== 'BlockTrade';
  });
});
var futuresSellOpenOrdersSelector = exports.futuresSellOpenOrdersSelector = (0, _reselect.createSelector)(futuresOpenOrdersCurrencySelector, function (orders) {
  return orders.filter(function (order) {
    return order.Side === 'Sell' && order.OrderType !== 'BlockTrade';
  });
});

// Helper function to process one side of the order book
var processSide = function processSide(rawData, openOrdersByPrice, side, instrument) {
  if (!instrument) {
    return [];
  }
  var Product1Symbol = instrument.Product1Symbol,
    Product2Symbol = instrument.Product2Symbol;

  // Process market data and merge with open orders
  return rawData.filter(function (order) {
    return order.ProductPairCode === instrument.InstrumentId;
  }).map(function (order) {
    var priceStr = order.Price.toString();
    var price = (0, _numberFormatter.currency)(order.Price, Product2Symbol);
    var quantity = (0, _numberFormatter.currency)(order.Quantity, Product1Symbol);

    // Check if user has orders at this price
    var userOrders = openOrdersByPrice[priceStr] || [];
    var matchingSideOrders = userOrders.filter(function (o) {
      return o.Side === side;
    });
    if (matchingSideOrders.length > 0) {
      // Merge user orders with market data
      var orderIds = matchingSideOrders.flatMap(function (o) {
        return o.OrderId ? [o.OrderId] : [];
      });
      var mySize = matchingSideOrders.reduce(function (total, o) {
        return total.plus(new _bignumber.BigNumber(o.Quantity));
      }, new _bignumber.BigNumber(0));
      return _objectSpread(_objectSpread({}, order), {}, {
        Price: price,
        Quantity: quantity,
        MySize: (0, _numberFormatter.currency)(mySize, Product1Symbol),
        OrderIds: orderIds
      });
    }

    // Just format market data
    return _objectSpread(_objectSpread({}, order), {}, {
      Price: price,
      Quantity: quantity
    });
  }).sort(function (a, b) {
    return b.Price.minus(a.Price);
  });
};

// Calculate spread efficiently
var calculateSpread = function calculateSpread(buy, sell) {
  if (!buy.length || !sell.length) return new _bignumber.BigNumber(0);
  var bestBuy = buy.length ? buy[0].Price : new _bignumber.BigNumber(0);
  var bestSell = sell.length ? sell[sell.length - 1].Price : new _bignumber.BigNumber(Infinity);
  return bestSell.minus(bestBuy);
};

// Optimized level2 selector
var optimizedFuturesLevel2Selector = exports.optimizedFuturesLevel2Selector = (0, _reselect.createSelector)([rawFuturesLevel2BuySelector, rawFuturesLevel2SellSelector, futuresOpenOrdersCurrencySelector, _futuresInstrumentsSelector.futuresSelectedInstrumentSelector], function (rawBuy, rawSell, allOpenOrders, selectedInstrument) {
  if (!selectedInstrument) {
    return {
      buy: [],
      sell: [],
      spread: new _bignumber.BigNumber(0)
    };
  }

  // Group orders by side
  var buyOrders = allOpenOrders.filter(function (order) {
    return order.Side === 0;
  });
  var sellOrders = allOpenOrders.filter(function (order) {
    return order.Side === 1;
  });

  // Merge orders at the same price level
  var mergedBuyOrders = (0, _orderHelper.mergeOpenOrders)(buyOrders);
  var mergedSellOrders = (0, _orderHelper.mergeOpenOrders)(sellOrders);

  // Index merged orders by price for O(1) lookup
  var openOrdersByPrice = {};

  // Add buy orders to index
  mergedBuyOrders.forEach(function (order) {
    var price = order.Price.toString();
    if (!openOrdersByPrice[price]) {
      openOrdersByPrice[price] = [];
    }
    openOrdersByPrice[price].push(order);
  });

  // Add sell orders to index
  mergedSellOrders.forEach(function (order) {
    var price = order.Price.toString();
    if (!openOrdersByPrice[price]) {
      openOrdersByPrice[price] = [];
    }
    openOrdersByPrice[price].push(order);
  });

  // Process buy and sell sides
  var processedBuy = processSide(rawBuy, openOrdersByPrice, 'Buy', selectedInstrument);
  var processedSell = processSide(rawSell, openOrdersByPrice, 'Sell', selectedInstrument);

  // Calculate spread
  var spread = calculateSpread(processedBuy, processedSell);
  return {
    buy: processedBuy,
    sell: processedSell,
    spread: spread
  };
});

// Public API selectors
var futuresLevel2BuySelector = exports.futuresLevel2BuySelector = (0, _reselect.createSelector)(optimizedFuturesLevel2Selector, function (level2) {
  return level2.buy;
});
var futuresLevel2SellSelector = exports.futuresLevel2SellSelector = (0, _reselect.createSelector)(optimizedFuturesLevel2Selector, function (level2) {
  return level2.sell;
});
var futuresLevel2Selector = exports.futuresLevel2Selector = (0, _reselect.createSelector)(optimizedFuturesLevel2Selector, function (level2) {
  return {
    buy: level2.buy,
    sell: level2.sell
  };
});
var futuresSpreadSelector = exports.futuresSpreadSelector = (0, _reselect.createSelector)([optimizedFuturesLevel2Selector, _futuresInstrumentsSelector.futuresSelectedInstrumentSelector], function (level2, selectedInstrument) {
  return (0, _numberFormatter.formatNumberToLocale)(level2.spread, selectedInstrument ? (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement) : 2);
});
//#endregion

//#region Recent Trades selectors
var selectRecentTradesState = function selectRecentTradesState(state) {
  return selectFuturesState(state).recentTrades;
};
var futuresRecentTradesFetchingSelector = exports.futuresRecentTradesFetchingSelector = function futuresRecentTradesFetchingSelector(state) {
  return selectRecentTradesState(state).fetching;
};
var selectActiveRecentTrades = exports.selectActiveRecentTrades = (0, _reselect.createSelector)([selectRecentTradesState, _futuresInstrumentsSelector.futuresSelectedInstrumentIdSelector], function (recentTrades, selectedInstrumentId) {
  return recentTrades[selectedInstrumentId];
});
var futuresRecentTradesSelector = exports.futuresRecentTradesSelector = (0, _reselect.createSelector)([selectRecentTradesState, _instrumentPositionSelectors.instrumentsWithProductFullNamesAndProductSymbols, _futuresInstrumentsSelector.futuresSelectedInstrumentIdSelector], function (recentTrades, instruments, selectedInstrumentId) {
  var tradesByInstrument = recentTrades[selectedInstrumentId];
  var instrument = instruments.find(function (item) {
    return item.InstrumentId === selectedInstrumentId;
  });
  if (!instrument || !tradesByInstrument) {
    return [];
  }
  var Product1Symbol = instrument.Product1Symbol,
    Product2Symbol = instrument.Product2Symbol;
  return tradesByInstrument.map(function (trade) {
    var quantity = (0, _numberFormatter.currency)(trade.Quantity, Product1Symbol);
    var price = (0, _numberFormatter.currency)(trade.Price, Product2Symbol);
    return _objectSpread(_objectSpread({}, trade), {}, {
      Quantity: quantity,
      Price: price
    });
  });
});
//#endregion

//#region Futures Inactive Orders selectors
// Basic selector for inactive orders data from state
var futuresInactiveOrdersBaseSelector = exports.futuresInactiveOrdersBaseSelector = (0, _reselect.createSelector)(selectFuturesOrdersState, function (orders) {
  return orders.inactiveOrders;
});

// Loading state selector
var futuresInactiveOrdersFetchingSelector = exports.futuresInactiveOrdersFetchingSelector = (0, _reselect.createSelector)(selectFuturesOrdersState, function (orders) {
  return orders.fetchingInactiveOrders;
});

// Main selector for filtered, processed inactive futures orders
var futuresInactiveOrdersSelector = exports.futuresInactiveOrdersSelector = (0, _reselect.createSelector)([futuresInactiveOrdersBaseSelector, _futuresSelectors.futuresAccountIdSelector, _futuresInstrumentsSelector.futuresSelectedInstrumentIdSelector, _instrumentPositionSelectors.instrumentsWithProductFullNamesAndProductSymbols], function (orders, accountId, selectedInstrumentId, instruments) {
  return orders.filter(function (order) {
    return (!accountId || order.Account === accountId) && selectedInstrumentId === order.Instrument;
  }).sort(function (a, b) {
    return b.ReceiveTime - a.ReceiveTime;
  }).map(function (order) {
    // Add instrument data to each order
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.Instrument;
    });
    return _objectSpread(_objectSpread({}, order), {}, {
      instrument: instrument
    });
  });
});
//#endregion

//#region Futures Filled Orders selectors
// Basic selector for filled orders data from state
var futuresFilledOrdersBaseSelector = exports.futuresFilledOrdersBaseSelector = (0, _reselect.createSelector)(selectFuturesOrdersState, function (orders) {
  return orders.filledOrders;
});

// Loading state selector
var futuresFilledOrdersFetchingSelector = exports.futuresFilledOrdersFetchingSelector = (0, _reselect.createSelector)(selectFuturesOrdersState, function (orders) {
  return orders.fetchingFilledOrders;
});

// Memoized selector for processing futures filled orders
var futuresFilledOrdersSelector = exports.futuresFilledOrdersSelector = (0, _reselect.createSelector)([futuresFilledOrdersBaseSelector, _futuresSelectors.futuresAccountIdSelector, _futuresInstrumentsSelector.futuresSelectedInstrumentIdSelector, _instrumentPositionSelectors.instrumentsWithProductFullNamesAndProductSymbols], function (orders, accountId, selectedInstrumentId, instruments) {
  // Filter by account if provided
  return orders.filter(function (order) {
    return (!accountId || order.AccountId === accountId) && selectedInstrumentId === order.InstrumentId;
  }).sort(function (a, b) {
    return b.TradeTimeMS - a.TradeTimeMS;
  }).map(function (order) {
    // Add instrument data to each order
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.InstrumentId;
    }) || {};

    // Calculate order value for displaying total
    var value = new _bignumber.BigNumber(order.Quantity).multipliedBy(new _bignumber.BigNumber(order.Price));
    return _objectSpread(_objectSpread({}, order), {}, {
      instrument: instrument,
      Value: value.toNumber(),
      // Ensure the Fee has a symbol property for rendering
      Fee: {
        amount: order.Fee,
        symbol: order.FeeCurrency || instrument.Product2Symbol || ''
      }
    });
  });
});

// Simple selector for getting all raw filled futures orders
var futuresFilledOrdersRawSelector = exports.futuresFilledOrdersRawSelector = (0, _reselect.createSelector)([futuresFilledOrdersBaseSelector, _instrumentPositionSelectors.instrumentsWithProductFullNamesAndProductSymbols], function (orders, instruments) {
  return orders.map(function (order) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.InstrumentId;
    }) || {};
    return _objectSpread(_objectSpread({}, order), {}, {
      instrument: instrument
    });
  });
});
//#endregion